import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';
import { BoostedJackpotIconSliderBoardWrapperProps } from '../../index.types';
import { BoostedJackpotIconSliderBoard } from './boostedJackpotIconSliderBoard';
import { useStore } from '../../../../../../hooks';

export const BoostedJackpotIconSliderBoardWrapper: React.FC<BoostedJackpotIconSliderBoardWrapperProps> = observer(({
  boostedJackpotIconInfoBoardRectangle,
  containerConfigBoostedJackpotIconSliderBoard,
}) => {
  const { boostedJackpotStore } = useStore();
  const { playerBoostedWinAmount, setPlayerBoostedWinAmount } = boostedJackpotStore;
  
  if (!playerBoostedWinAmount) return null;
  
  return (
    <Container {...containerConfigBoostedJackpotIconSliderBoard as any}>
      <BoostedJackpotIconSliderBoard
        playerBoostedWinAmount={playerBoostedWinAmount}
        setPlayerBoostedWinAmount={setPlayerBoostedWinAmount}
        boostedJackpotIconInfoBoardRectangle={boostedJackpotIconInfoBoardRectangle}
      />
    </Container>
  );
});
